import '../CreateArea.scss';
import React, { useEffect, useState } from "react";
import shapeIcon from '../../../../assets/icons/shape-icon.png';
import houseIcon from '../../../../assets/icons/house-icon.png';
import DrawPolygon from './DrawPolygon';
import EnterAddress from './EnterAddress';
import axios from 'axios';
import { useUserContext } from '../../../../contexts/UserContext';
import { useAreasContext } from '../../../../contexts/AreasContext';
import { 
    HouseIcon
} from "@phosphor-icons/react";

export default function CreateArea(props) {
    const {
        getToken
    } = useUserContext();

    const {
        teamAreas,
        setTeamAreas,
        myAreas,
        setMyAreas,
        plotAreas
    } = useAreasContext();

    const {
        setPanel, 
        user, 
        map, 
        draw
    } = props;

    const [stage, setStage] = useState('menu');
    const [choice, setChoice] = useState(null);
    const [teams, setTeams] = useState(null);

    const choices = [
        {
            title: 'Draw Polygon',
            stage: 'draw-polygon',
            description: 'Create your own Monitoring Area by defining a custom polygon using points on the map.',
            img: shapeIcon
        },
        {
            title: 'Enter Address',
            stage: 'enter-address',
            description: 'Create your own Monitoring Area by entering an Address and defining a custom radius / proximity.',
            img: houseIcon
        }
    ]

    const getTeams = () => {
        getToken().then((token) => {
            axios.get(`https://firewatch-api.space-eyes.com/teams`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then((response) => {
                setTeams(response.data.teams);
            }).catch((error) => {
                console.log('error getting teams', error)
            })
        }).catch((err) => {
            console.log('error getting token', err);
        })
    }

    useEffect(() => {
        getTeams();
    }, []);
   
    const stageSwitch = () => {
        switch (stage) {
            case 'menu':
                return (
                    <div className='create-area-content-menu'>
                        {choices.map((c) => {
                            return (
                                <div 
                                    key={c.stage}
                                    className={`create-area-content-menu-choice ${choice === c.stage ? 'selected' : ''}`}
                                    onClick={() => setChoice(c.stage)}
                                    >
                                    <div className='create-area-content-menu-choice-title'>
                                        <img className='create-area-content-menu-choice-title-icon' src={c.img}/>
                                        <div className='create-area-content-menu-choice-title-text'>{c.title}</div>
                                    </div>
                                    <div className='create-area-content-menu-choice-description'>{c.description}</div>
                                </div>
                            )
                        })}
                        <div 
                            className={choice ? 'create-area-content-menu-next-btn' : 'create-area-content-menu-disabled-btn'}
                            onClick={() => {
                                setStage(choice)
                            }}
                            >Next</div>
                    </div>
                )
            case 'draw-polygon':
                return (
                   <DrawPolygon 
                        setPanel={setPanel}
                        user={user}
                        map={map}
                        draw={draw}
                        teams={teams}
                        getToken={getToken}
                        teamAreas={teamAreas}
                        setTeamAreas={setTeamAreas}
                        myAreas={myAreas}
                        setMyAreas={setMyAreas}
                        plotAreas={plotAreas}
                   />
                )
            case 'enter-address':
                return (
                    <EnterAddress 
                        map={map}
                        user={user}
                        setPanel={setPanel}
                        myAreas={myAreas}
                        setMyAreas={setMyAreas}
                        teamAreas={teamAreas}
                        setTeamAreas={setTeamAreas}
                        plotAreas={plotAreas}
                        getToken={getToken}
                        teams={teams}
                    />
                )
        }
    }

    return (
        <div className='create-area'>
            <div className='create-area-title'>
                <div className='create-area-title-text'>Create New Area</div>
            </div>
            <div className='create-area-description'>Receieve fire data and alerts for a specific Monitoring Area by defining custom bounds.</div>
            <div className='create-area-content'>
                {stageSwitch(stage)}
            </div>
        </div>
    );
}